import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@activecollab/components";
import classnames from "classnames";
import PropTypes from "prop-types";
import { AttachmentMenuPicker } from "./menu/index.jsx";
import { keyCodes } from "../../utils/key_codes.jsx";
import { useFileIntegrations } from "../Hooks/useFileIntegrations.jsx";

export const SelectAttachmentControl = ({ filesToAttach, hasAttachments, openFileWindow, ...rest }) => {
  const { t } = useTranslation();
  const { hasAttachmentIntegration } = useFileIntegrations();

  const onKeydownEvent = useCallback(
    (event) => {
      // when focused we need to open file input on enter,
      if (event.key === keyCodes.enter) {
        typeof openFileWindow === "function" && openFileWindow();
      }
    },
    [openFileWindow]
  );

  return (
    <div
      className={classnames(`select_attachments_control`, {
        select_attachments_control_empty: !filesToAttach.length && !hasAttachments,
      })}
    >
      <div className="tw-flex tw-items-center tw-justify-between">
        <div>
          <span className="select_attachments_title tw-truncate tw-mr-1">{t("Attachments")}</span>
          <span className="select_attachments_subtitle">({t("you can drag and drop here")})</span>
        </div>
        {hasAttachmentIntegration ? (
          <AttachmentMenuPicker
            {...rest}
            openFileWindow={openFileWindow}
            target={
              <Button
                type="button"
                size="small"
                variant="outlined"
                tabIndex={0}
                className="btn btn--small select_attachments_trigger upload-files on-focus tw-shrink-0 tw-ml-2"
              >
                {t("Attach Files")}
              </Button>
            }
          />
        ) : (
          <Button
            type="button"
            size="small"
            variant="outlined"
            tabIndex={0}
            className="btn btn--small select_attachments_trigger upload-files on-focus tw-shrink-0 tw-ml-2"
            onKeyDown={onKeydownEvent}
            onClick={openFileWindow}
          >
            {t("Attach Files")}
          </Button>
        )}
      </div>
    </div>
  );
};

SelectAttachmentControl.propTypes = {
  hasAttachments: PropTypes.bool,
  filesToAttach: PropTypes.arrayOf(PropTypes.string),
  openFileWindow: PropTypes.func,
};

SelectAttachmentControl.defaultProps = {
  hasAttachments: false,
};
